'use client';

import { useApi } from '@repo/api';
import { createUserFetcher } from '@repo/form';
import { useSuspenseQuery } from '@repo/tanstack/query';

/** Active Users for Saved View owner and audience pickers. Everyone can use tables, so no permission filter. */
export const ActiveUserFetcher = createUserFetcher(({
  search
}) => {
  const api = useApi();
  return useSuspenseQuery(api.users.list.queryOptions({
    input: {
      'filter[statuses]': 'active',
      perPage: 20,
      search: search || undefined
    }
  })).data.data;
});